export default "__VITE_ASSET__ELBN4S_Z__"